/**
 * @description Given content and substitutions objects, iterate over both objects and replace instances of the substitution keys in the content values.
 * @param {Object} content - The original content before substitutions are applied.
 * @param {Object} substitutions - The substitutions to be applied.
 * @return {Object} The content with the substitutions applied.
 */
function updateContentWithSubstitutions(content, substitutions) {
  for (var contentKey in content) {
    for (var substitutionsKey in substitutions) {
      var _content$contentKey;
      content[contentKey] = (_content$contentKey = content[contentKey]) === null || _content$contentKey === void 0 ? void 0 : _content$contentKey.replace(substitutionsKey, substitutions[substitutionsKey]);
    }
  }
  return content;
}

export { updateContentWithSubstitutions };
